<template>
  <section class="documents-section">
    <article class="documents-section__panel">
      <div class="documents-section__head">
        <div>
          <h3>Listado de documentos cargados</h3>
          <p>Consulta los documentos cargados dentro del proceso de inscripción.</p>
        </div>

        <span class="documents-section__summary">
          {{ documents.length }} documento(s)
        </span>
      </div>

      <div v-if="documents.length > 0" class="documents-section__list">
        <article
          v-for="documentItem in documents"
          :key="documentItem.id"
          class="documents-section__row"
        >
          <div class="documents-section__content">
            <div class="documents-section__title-row">
              <strong>{{ documentItem.name }}</strong>
            </div>

            <p class="documents-section__note">{{ documentItem.note }}</p>
          </div>

          <div class="documents-section__status-block">
            <span class="documents-section__status" :class="statusClass(documentItem.status)">
              {{ documentItem.status }}
            </span>
          </div>
        </article>
      </div>

      <p v-if="documents.length > 0" class="documents-section__footer-note">
        * Recuerda que los documentos se encuentran en revisión por parte del área de registro y control.
      </p>

      <div v-else class="documents-section__empty">
        No hay documentos obligatorios registrados para esta inscripcion.
      </div>
    </article>
  </section>
</template>

<script>
export default {
  name: 'GraduationDocumentsSection',
  props: {
    documents: {
      type: Array,
      required: true,
    },
  },
  methods: {
    statusClass (status) {
      if (status === 'OK' || status === 'Aprobado' || status === 'CARGADO') {
        return 'is-success'
      }

      return 'is-warning'
    },
  },
}
</script>

<style scoped>
.documents-section__panel {
  background: #fff;
  border: 1px solid var(--ibero-border);
  border-radius: 12px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.05);
  padding: 22px;
}

.documents-section__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.documents-section__head h3 {
  margin: 0;
  color: var(--ibero-primary);
  font-size: 19px;
  font-weight: 700;
}

.documents-section__head p {
  margin: 8px 0 0;
  color: var(--ibero-muted);
  font-size: 14px;
}

.documents-section__summary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 999px;
  background: var(--ibero-primary-soft);
  color: var(--ibero-primary);
  font-size: 12px;
  font-weight: 700;
}

.documents-section__list {
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-top: 22px;
}

.documents-section__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 150px;
  gap: 18px;
  padding: 18px;
  border: 1px solid var(--ibero-border);
  border-radius: 10px;
  background: #fff;
}

.documents-section__content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.documents-section__title-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  color: var(--ibero-text);
}

.documents-section__note {
  margin: 0;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.6;
}

.documents-section__empty {
  margin-top: 22px;
  padding: 18px;
  border: 1px dashed var(--ibero-border);
  border-radius: 10px;
  color: var(--ibero-muted);
  font-size: 14px;
  text-align: center;
}

.documents-section__footer-note {
  margin: 18px 0 0;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.6;
}

.documents-section__status-block {
  display: flex;
  justify-content: flex-end;
}

.documents-section__status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
  height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
}

.documents-section__status.is-success {
  background: rgba(34, 139, 34, 0.12);
  color: #206a20;
}

.documents-section__status.is-warning {
  background: rgba(242, 169, 0, 0.16);
  color: #8a6200;
}

@media (max-width: 860px) {
  .documents-section__head {
    flex-direction: column;
    align-items: flex-start;
  }

  .documents-section__row {
    grid-template-columns: 1fr;
  }

  .documents-section__status-block {
    justify-content: flex-start;
  }
}
</style>
